export const schemaPlaces: TableSchema<CampaignPlace> = {
  title: {
    title: 'Locais',
    render: rowData => rowData.name,
    className: 'order__details col__infos col__title',
    showTotal: true
  }
}
